import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "#6E84A1",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.4",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M6.413 12.321H3.676c-.807 0-1.21 0-1.518-.157a1.44 1.44 0 0 1-.63-.63c-.156-.307-.156-.71-.156-1.517V4.544c0-.807 0-1.21.157-1.518a1.44 1.44 0 0 1 .629-.63c.308-.157.711-.157 1.518-.157h8.354c.806 0 1.21 0 1.518.157.27.138.491.359.63.63.156.308.156.711.156 1.518V5.84m-.283-1.251-3.642 2.427c-.924.616-1.386.924-1.885 1.044a2.9 2.9 0 0 1-1.343 0c-.499-.12-.96-.428-1.885-1.044L1.478 4.471m7.815 9.29 1.458-.291a1.5 1.5 0 0 0 .25-.062.7.7 0 0 0 .15-.08c.052-.036.097-.081.19-.173l2.993-2.994a1.018 1.018 0 1 0-1.44-1.44L9.9 11.714a1.5 1.5 0 0 0-.174.19.7.7 0 0 0-.08.15c-.023.059-.036.122-.061.25z" }, null, -1 /* CACHED */)
  ]))]))
}
export default { render: render }